import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const {FiSun,FiMoon}=FiIcons;

const ThemeToggle=({darkMode,toggleDarkMode})=> {
  return (
    <button onClick={toggleDarkMode} className="relative inline-flex items-center justify-center p-2 rounded-full bg-white dark:bg-gray-800 shadow-sm hover:shadow-md transition-all duration-300 group" aria-label="Toggle dark mode" >
      <div className="relative w-4 h-4">
        <SafeIcon icon={FiSun} className={`absolute inset-0 text-yellow-500 transition-all duration-300 transform ${darkMode ? 'opacity-0 rotate-180 scale-0' : 'opacity-100 rotate-0 scale-100'}`} />
        <SafeIcon icon={FiMoon} className={`absolute inset-0 text-blue-600 transition-all duration-300 transform ${darkMode ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-180 scale-0'}`} />
      </div>
      <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-xs text-gray-500 dark:text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        {darkMode ? 'Light Mode' : 'Dark Mode'}
      </span>
    </button>
  );
};

export default ThemeToggle;